// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e7025f0d","452":"97bbaa7d","796":"f1e1c194"}[chunkId] + ".chunk.js";
};